import React from 'react'
import './navbar.css'
import { FaBars } from 'react-icons/fa'
import { useState, useEffect } from 'react'
import Links from './Links'

var yOffset;

function Navbar() {

  const [showMenu, setShowMenu] = useState(false)
  const toggleShowMenu = () => setShowMenu(prev => !prev)

  const [atTop, setAtTop] = useState(window.pageYOffset === 0)
  const [showNavBar, setShowNavBar] = useState(true)
  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const handleScroll = () => {
    const lasOffSet = yOffset
    yOffset = window.pageYOffset
    if (yOffset > lasOffSet) setShowNavBar(false)
    else if (yOffset < lasOffSet) setShowNavBar(true)
    if (window.pageYOffset === 0) {
      setShowNavBar(true)
      setAtTop(true)
    } else {
      setAtTop(false)
    }
  }
  return (
    <div className={`navbar ${!showNavBar && "navbar-hidden"} ${!atTop && "navbar-scrolled"}`}>
      <h2>Vincent <span className="lastname">Cai</span></h2>
      <div className="navbar-links">
        <Links />
      </div>
      <div className="navbar-menu">
        <FaBars onClick={toggleShowMenu} />
        <div className={`navbar-menu-dropdown ${showMenu && "navbar-menu-dropdown-show"}`}>
          <Links onClick={toggleShowMenu} />
        </div>
        {showMenu && <div className="navbar-blurBackground" />}
      </div>
    </div>
  )
}

export default Navbar
